module.exports = __webpack_public_path__ + "static/media/message.ca06c1e.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/video/message.mp3
// module id = 0poS
// module chunks = 1